import React from 'react'
import { Router } from '@reach/router'
import {
  LoadingSpinner,
  PAYPAL_THEME,
  ThemeWrapper,
} from '@paypalcorp/pp-react'
import Analytics from './lib/Analytics'
import { Logger as clientLogger, LOG_LEVEL } from 'beaver-logger'
import ppEnv from 'environment-paypal'
import serverData from './utils/server-data'
import { get } from 'lodash'

const logger = clientLogger({
  url: '/mobile-app/log',
  // Log level to display in the browser console (only in dev)
  logLevel:
    ppEnv.isProd() || process.env.NODE_ENV === 'production'
      ? LOG_LEVEL.WARN
      : LOG_LEVEL.DEBUG,
})

const AppDownload = React.lazy(() => import('./screens/app-download'))

function App() {
  Analytics.init()

  logger.info('CLIENT', {
    m_flow: serverData.flow || '',
    m_deep_link: serverData.deepLinkPath || '',
    m_src: serverData.source || '',
    m_browser: get(serverData, 'deviceDetails.browserName', ''),
    m_browser_version: get(serverData, 'deviceDetails.browserVersion', ''),
    m_device_os: get(serverData, 'deviceDetails.deviceOS', ''),
    m_device_os_version: get(serverData, 'deviceDetails.deviceOSVersion', ''),
    m_device_type: get(serverData, 'deviceDetails.deviceType', ''),
    m_platform: get(serverData, 'deviceDetails.platform', ''),
    message: 'Loading App component',
  })

  return (
    <ThemeWrapper theme={PAYPAL_THEME}>
      <div data-testid="app-container">
        <React.Suspense
          fallback={
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
              }}
            >
              <LoadingSpinner screenReaderText="loading" size="xl" />
            </div>
          }
        >
          <Router>
            <AppDownload path="/*" />
          </Router>
        </React.Suspense>
      </div>
    </ThemeWrapper>
  )
}

export default App
